import { HandleEvent } from './eventhandler.js';
export function SaveSnapshot (viewer)

{

    


	//console.log("viewer = " + viewer);
	let size = [1280,720];
	//HandleEvent('snapshot_created', size);
    let url = GetImageUrlS (viewer);
	console.log("one and only one that matters: " + url);

	function GetImageUrlS (viewer)
    { 	
        return viewer.GetImageAsDataUrl (432, 243, true);
    }
	return url;
    
}
